export default () => ({
    skip: 1,
    slider: null,
    active: 1,
    total: null,
    interval: 3000,
    autoplay: false,
    direction: 'right',
    leftArrow: false,
    rightArrow: true,
    scrollWidth: 0,
    clientWidth: 0,
    scrollLeft: 0,
    init() {

        this.$nextTick(() => {
            this.total = this.$refs.slider.children.length;
        });
    },

    next() {
        this.to((current, offset) => current + (offset * this.skip))
    },
    prev() {
        this.to((current, offset) => current - (offset * this.skip))
    },
    
    to(strategy) {
        let slider = this.$refs.slider
        let current = slider.scrollLeft
        let offset = slider.firstElementChild.getBoundingClientRect().width

        slider.scrollTo({ left: strategy(current, offset), behavior: 'smooth' })
    },

    focusableWhenVisible: {
        'x-intersect:enter'() {
            this.$el.removeAttribute('tabindex')
        },
        'x-intersect:leave'() {
            this.$el.setAttribute('tabindex', '-1')
        },
    },

    toggleArrow(scrollLeft) {
        this.scrollLeft = scrollLeft;
        this.scrollLeft > 1 ? this.leftArrow = true : this.leftArrow = false;
        this.scrollLeft >= this.scrollWidth - this.clientWidth +- 1 ? this.rightArrow = false : this.rightArrow = true;
    },

    updateWidth(scrollWidth, clientWidth) {
        this.scrollWidth = scrollWidth;
        this.clientWidth = clientWidth;
    },

    initWidth(scrollWidth, clientWidth, scrollLeft) {
        this.scrollWidth = scrollWidth;
        this.clientWidth = clientWidth;
        this.scrollLeft = scrollLeft;
    }
})